import type React from 'react';

import { useGetFace } from '@vlabs/api/artemy/client';
import type { FaceId } from '@vlabs/api/artemy/model';
import { PageHeader } from '@vlabs/monokit/shared/ui/page';
import { Breadcrumb, Breadcrumbs } from '@vlabs/uikit';
import { routes } from '@vlapps/point/src/app/routes';
import { useTranslation } from 'react-i18next';
import { generatePath } from 'react-router-dom';

interface FacePageHeaderProps {
  faceId: FaceId;
}

function FacePageHeader({
  faceId,
}: FacePageHeaderProps): React.JSX.Element {
  const { t } = useTranslation();
  const getFace = useGetFace(faceId);

  return (
    <PageHeader
      breadcrumbs={(
        <Breadcrumbs>
          <Breadcrumb
            caption={t('face-page:header.breadcrumbs.cards_and_lists')}
            href={generatePath(routes.cardsAndLists.activeTab, { activeTab: 'cards' })}
          />
          <Breadcrumb
            caption={t('face-page:header.breadcrumbs.card')}
            href={getFace.data?.card_id
              ? generatePath(routes.externalId.read, { externalId: getFace.data?.card_id })
              : undefined}
          />
          <Breadcrumb caption={t('face-page:header.breadcrumbs.face')} />
        </Breadcrumbs>
      )}
      title={t('face-page:header.title')}
    />
  );
}

export { FacePageHeader };
